<script lang="ts" setup>
import { useCheckoutStore } from '@stores/checkout'

import { LoaderFullScreenDomain } from '@UI/Loaders/LoaderFullScreenDomain'

defineOptions({
  name: 'LayoutCheckout',
})

const checkoutStore = useCheckoutStore()
</script>

<template>
  <div class="cs-order">
    <slot
      v-if="checkoutStore.isOrderId"
    />
    <!-- TODO(INFRA-724): error block with retry; a failed order fetch shows the loader until then -->
    <LoaderFullScreenDomain v-else />
  </div>
</template>

<style scoped lang="scss" src="@scss/layouts/order.scss" />
